import { Component, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivationStart, NavigationEnd, Router } from "@angular/router";
import { environment } from "src/environments/environment.dev";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'app-main-layout',
    templateUrl: './main.layout.html',
    styleUrls: ['./main.layout.scss'],
    imports: [RouterOutlet]
})

export class MainLayout implements OnInit {
  private readonly route = inject(Router);
  private readonly title = inject(Title);

  ngOnInit(){
    //TODO: Agregar codigo init
    this.route.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
        const title = `${environment.app} - ${event.snapshot.data['title'] ?? 'CRM'}`;
        this.title.setTitle(title);
      }
    });
  }
}
